import React from 'react';
import styled from 'styled-components';
import { Container } from '@volkswagen-onehub/components-core';

const BackgroundGtiColor = styled.section`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;

  background-image: url('https://assets.volkswagen.com/is/image/volkswagenag/black-background?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJmRjYzM=');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const TitleWrapper = styled.div`
  --title-size: clamp(40px, 12vw, 150px);

  position: relative;
  text-align: center;
  margin-top: 15vh;

  padding-bottom: calc(var(--title-size) * 1.3);

  @media screen and (max-width: 560px) {
    margin-top: 30vh;

    padding-bottom: calc(var(--title-size) * 1.2);
  }
`;

const TitleText = styled.h2`
  margin: 0;
  color: #c90010;
  font-family: 'Futura Condensed Extra Bold', Futura, Arial, sans-serif;
  font-stretch: condensed;
  line-height: 1;
  letter-spacing: -0.06em;
  font-size: var(--title-size);
  position: relative;
  z-index: 1;
`;

const SvgDecoration = styled.img`
  position: absolute;
  transform: translateX(-50%);
  z-index: 2;
  pointer-events: none;

  width: calc(var(--title-size) * 8);
  max-width: 70vw;

  top: calc(100% - var(--title-size) * 2.5);
`;

export const EndModuleGti50 = (): React.ReactElement => {
  return (
    <BackgroundGtiColor>
      <Container wrap="always" verticalAlign="center">
        <TitleWrapper>
          <TitleText>
            TODOS LOS COCHES <br /> TIENEN MOTOR
          </TitleText>
          <SvgDecoration
            src="https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-gti50/no-todos-tienen-alma.png"
            alt="no todos los coches tienen alma"
          />
        </TitleWrapper>
      </Container>
    </BackgroundGtiColor>
  );
};
